import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-alleen',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconAlleen {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="m14.2 5.29.12.03c.56.13 1.12.2 1.66.2 2.07 0 4.08-.86 5.53-2.36l1.6-1.58 1.37 1.36a7.68 7.68 0 0 0 3.07 2.09l.22.08-.07-.23C26.8 1.96 24.05-.08 21-.08s-5.97 2.16-6.77 5.25l-.03.11Zm-.18 2.06v.16c.31 3.6 3.38 6.41 6.98 6.41s6.76-2.89 6.98-6.58v-.1l-.65-.13a9.545 9.545 0 0 1-4.15-2.77l-.09-.1-.09.1c-1.79 2.06-4.36 3.24-7.03 3.24-.59 0-1.19-.07-1.8-.19l-.15-.03Zm16.96 13.64.03 9.98c0 .54-.44.99-.98 1l-2.04.04-.04 2.93c0 .55-.44 1-.99 1l-11.91.07c-.55 0-1-.45-1-1V20h-.61c-4.52 0-7.42-3.74-7.42-8v-.93c0-.56.46-1.01 1.01-1l2 .03c.55 0 .99.45.99 1v.9c0 2.09 1.07 4 3.42 4H26c2.81 0 4.99 2.19 4.99 5ZM7.53 8H9c.55 0 1-.45 1-1V1c0-.55-.44-1-1-1S8 .45 8 1l-.02 2H7.5a2.5 2.5 0 0 0 0 5h.04Z"/>
</svg>

    );
  }
}
